import { render, staticRenderFns } from "./descriptive_balance_detailsprint.vue?vue&type=template&id=3eb6b936&"
import script from "./descriptive_balance_detailsprint.vue?vue&type=script&lang=js&"
export * from "./descriptive_balance_detailsprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports